<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="ParentData"
                ref="master"
                :actions="false"
      >
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'user_role',
          actions: false,
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id_user_role'
            },
            columns: [
              {title: 'Usuario autorizado', dataIndex: 'user_name', sorter: true},
              {title: 'Rol', dataIndex: 'role_name', sorter: true},
            ]
          }
        }
      }
    },
    props: ['name'],
    computed: {
      ParentData () {
        return {
          role_name: this.name
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/UsersByRol.vue